module.exports = __webpack_public_path__ + "assets/img/antzemine-elektrines.db86f346.webp";